export function utilities() {

	let fullPageHeight      = $('.js-page-full-height');
	let bgBlue              = $('.js-body-bg-blue');

	if(fullPageHeight.length) {
		fullPageHeight.closest('body').addClass('page--full-height')
	}

	if(bgBlue.length) {
		bgBlue.closest('body').addClass('bg--blue')
	}

	return 'utilities';
}

export function aosDelay() {

	let items   = $('.js-aos-delay');
	let counter = 200;

	items.each(function() {
		$(this).attr('data-aos-delay', counter);
		counter = counter + 100;
	});

	return 'aosDelay';
}